const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

const API_URL_LOCAL = process.env.REACT_APP_BASE_URL_LOCAL;
const API_URL_PROD = process.env.REACT_APP_BASE_URL_PROD;
const API_URL_CENTRAL_DATA_LOCAL =
  process.env.REACT_APP_BASE_URL_CENTRAL_DATA_LOCAL;
const API_URL_CENTRAL_DATA_PROD =
  process.env.REACT_APP_BASE_URL_CENTRAL_DATA_LOCAL_PROD;

// const DOMAIN_LOCAL = process.env.REACT_DOMAIN_LOCAL;
// const DOMAIN_PROD = process.env.REACT_DOMAIN_PROD;

// Access-Key for Open Api
const ACCESS_KEY_OPEN_API = process.env.ACCESS_KEY_OPEN_API;

const SOCKET_URL_LOCAL = process.env.REACT_APP_ONLINE_USER_URL_LOCAL;
const SOCKET_URL_PROD = process.env.REACT_APP_ONLINE_USER_URL_PROD_SOCKET;
const config = {
  base: {
    url: API_URL_LOCAL,
  },
  ws: {
    url: SOCKET_URL_LOCAL,
  },
  central: {
    url: API_URL_CENTRAL_DATA_LOCAL,
  },
  accessKey_open_api: {
    key: ACCESS_KEY_OPEN_API,
  },
  domain: ".localhost",
  ENVIRONMENT,
};

//CHECK FOR ENVIRONMENT
if (ENVIRONMENT === "prod") {
  config.base.url = API_URL_PROD;
  config.ws.url = SOCKET_URL_PROD;
  config.domain = "themajesticai.com";
  config.central.url = API_URL_CENTRAL_DATA_PROD;
} else {
  config.base.url = API_URL_LOCAL;
  config.ws.url = SOCKET_URL_LOCAL;
  config.domain = "localhost";
  config.central.url = API_URL_CENTRAL_DATA_LOCAL;
}

export { config, ENVIRONMENT };
